import { render, staticRenderFns } from "./Irregularidades.vue?vue&type=template&id=f361755e&lang=pug&"
import script from "./Irregularidades.vue?vue&type=script&lang=js&"
export * from "./Irregularidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports